import type { SVGProps } from 'react';

const SvgLineSearchNormal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.501 8.047a5.834 5.834 0 1 0-11.668.002 5.834 5.834 0 0 0 11.668-.002m1 0A6.834 6.834 0 1 1 .832 8.046a6.834 6.834 0 0 1 13.669 0M12.98 13.36a.5.5 0 0 1 .63-.065l.078.065 1.333 1.333.064.079a.5.5 0 0 1-.692.692l-.08-.064-1.332-1.333-.065-.078a.5.5 0 0 1 .065-.63'
      fill='#3889FF'
    />
  </svg>
);
export default SvgLineSearchNormal;
